import { proxy } from "valtio";
import { ModalState } from "../types";

export const ModalStore = proxy<ModalState>({
  appVersionUpdateModalVisible: false,
  appRatingModalVisible: false,
});

// APP 升级弹窗调用，关闭其他弹窗
export const closeOtherModals = () => {
  ModalStore.appRatingModalVisible = false;
};
